import { get, post } from '../actions/method';
import helper from '../utils/helper';

export const downloadTemplate = async (format, queryObj) => {
  const params = {
    responseType: 'blob',
  };
  return await get(`app/sensorCalibrationSwap/template`, params)
    .then((resp) => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Calibration-swap-template.xlsx`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => console.log(err));
};

export const validateCalibrationSwapFile = async (file) => {
  const formData = new FormData();
  formData.set('file', file);
  const params = {
    body: formData,
  };
  return await post('app/sensorCalibrationSwap/validate', params);
};

export const commitCalibrationSwapFile = async (file) => {
  const formData = new FormData();
  formData.set('file', file);
  const params = {
    body: formData,
  };
  return await post('app/sensorCalibrationSwap/commit', params);
};

export const downloadCalibrationReport = async (commitId) => {
  const params = {
    responseType: 'blob',
  };
  return await get(`app/sensorCalibrationSwap/${commitId}/report`, params)
    .then((resp) => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Report.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => console.log(err));
};
